import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CounterResultsComponent } from './counter-results.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { RouterModule } from '@angular/router';
import { LocalLoaderComponent } from '../../../../../components/loader/local-loader/local-loader.component';
import { AlertComponent } from '../../../../../components/alert/alert.component';
import { defaultOccContentConfig } from './core/counter-results.occ';

@NgModule({
  declarations: [CounterResultsComponent],
  imports: [CommonModule, I18nModule, RouterModule, LocalLoaderComponent, AlertComponent],
  providers: [
    provideConfig(defaultOccContentConfig),
    provideConfig(<CmsConfig>{
      cmsComponents: {
        PLPCounterResults: {
          component: CounterResultsComponent,
        },
      },
    }),
  ],
})
export class CounterResultsModule {}
